class CartNotification extends HTMLElement {
    constructor() {
        super();
        this.cartOpen = false;
        this.notification = document.getElementById("cart-notification");
        this.notification.classList.add("loaded");
        this.header = document.querySelector("sticky-header");
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.positionScreen;

        this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton) => closeButton.addEventListener("click", this.close.bind(this)));
        document.querySelector("#cart-icon-bubble").addEventListener("click", this.openCart.bind(this));
        this.querySelector(".modal-overlay").addEventListener("click", this.openCart.bind(this));
        this.querySelector("#close-cart").addEventListener("click", () => this.querySelector(".modal-overlay").click());
    }

    openCart(e) {
        e ? e.preventDefault() : null;
        if (this.cartOpen) this.close();
        else this.open();
    }

    open() {
        this.notification.classList.add("animate");
        this.classList.add("show");
        setTimeout(() => {

            const parentElement = document.querySelector('.header-checker');
            const childElement = parentElement.querySelector('.logged-out');

            let elmWishlistDrawer = document.querySelector("wishlist-notification");
            let accountHeader = document.querySelector(".mega-nav-login-form");
            if (elmWishlistDrawer) {
                if (elmWishlistDrawer.cartOpen) elmWishlistDrawer.close();
            }

            if (childElement) {
                if (accountHeader.classList.contains('show')) {
                    document.querySelector('.mega-nav-login-form').classList.remove('show');
                    document.querySelector('.image-white').style.display = 'flex';
                    document.querySelector('.image-black').style.display = 'none';
                }
                if (accountHeader.classList.contains('show-mega')) {
                    document.querySelector('.mega-nav-login-form').classList.remove('show-mega');
                    document.querySelector('.image-white').style.display = 'flex';
                    document.querySelector('.image-black').style.display = 'none';
                }
            }

            this.notification.classList.add("active");
            document.body.classList.add("blur-body");
            this.positionScreen = window.pageYOffset;
            fixedBody(this.positionScreen);
        }, 100);

        this.notification.addEventListener(
            "transitionend",
            () => {
                this.notification.focus();
                trapFocus(this.notification);
            },
            { once: true }
        );
        this.setActiveElement(document.activeElement);

        // document.body.addEventListener("click", this.onBodyClick);
        console.log("blur");
        this.cartOpen = true;
    }

    close() {
        this.notification.classList.remove("active");
        this.classList.remove("show");
        document.body.classList.remove("blur-body");
        fixedBody(this.positionScreen);
        setTimeout(() => {
            this.notification.classList.remove("animate");
        }, 300);
        document.body.removeEventListener("click", this.onBodyClick);

        removeTrapFocus(this.activeElement);
        this.cartOpen = false;
    }

    autoClose() {
        let timeClose = Number(this.dataset.autoClose) * 1000 || 2000;
        setTimeout(() => {
            if (this.cartOpen) this.close();
            // this.closest("details-modal").querySelector("summary").click();
        }, timeClose);
    }

    renderContents(parsedState) {
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });

        if (this.header) this.header.reveal();
        this.open();
        // this.closest("details-modal").querySelector("summary").click();
    }

    reRenderContents(parsedState) {
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
    }

    getSectionsToRender() {
        return [
            {
                id: "cart-notification-product",
                selector: `#shopify-section-cart-notification-product`,
            },
            // {
            //     id: "cart-notification-button",
            // },
            {
                id: "cart-icon-bubble",
            },
        ];
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest("cart-notification")) {
            const disclosure = target.closest("details-disclosure");
            this.activeElement = disclosure ? disclosure.querySelector("summary") : null;
            this.close();
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define("cart-notification", CartNotification);

class CartRemoveButton extends HTMLElement {
    constructor() {
        super();
        this.notification = document.querySelector("cart-notification");
        this.addEventListener("click", (event) => {
            event.preventDefault();
            this.updateQuantity(this.dataset.index, 0);
        });
    }
    updateQuantity(line, quantity, name) {
        const body = JSON.stringify({
            line,
            quantity,
            sections: this.notification.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.notification.reRenderContents(parsedState);
            })
            .catch((e) => {
                console.error(e);
            });
    }
}

customElements.define("cart-remove-button", CartRemoveButton);
